import { Link } from "react-router-dom";
import { categories } from "@/mocks/site";
import { getMediaByType } from "@/lib/data";

export default function CategoryEntries() {
  return (
    <section className="mx-auto max-w-[1280px] px-4 py-10 md:px-8 md:py-14">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5 lg:grid-cols-3">
        {categories.map((cat, i) => {
          const count = getMediaByType(cat.type).length;
          return (
            <Link
              key={cat.type}
              to={`/category/${cat.type}`}
              className={`group relative overflow-hidden rounded-lg border border-background-200/60 animate-fade-up delay-${i + 1} ${
                i === 0 ? "sm:col-span-2 lg:col-span-1" : ""
              }`}
            >
              <div className="relative h-48 w-full overflow-hidden md:h-56">
                <img
                  src={cat.cover}
                  alt={`${cat.name}频道`}
                  title={`${cat.name}频道-榴莲视频`}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/50 to-transparent"></div>
              </div>
              <div className="absolute inset-x-0 bottom-0 p-5">
                <div className="flex items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                    <i className={`${cat.icon} text-2xl`}></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-lg font-bold text-foreground-950">{cat.name}</h3>
                    <p className="text-xs text-foreground-400">
                      {cat.englishName} · {count}+ 部在库
                    </p>
                  </div>
                </div>
                <p className="mt-3 dv-clamp-1 text-sm text-foreground-400">{cat.slogan}</p>
              </div>
              <span className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full bg-background-50/70 text-foreground-500 backdrop-blur-sm transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
                <i className="ri-arrow-right-up-line text-lg"></i>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}